export interface WicketUserList {
  name: string;
  email: string;
}
